<div class="context-sentence">
  <div class="context-line context-pay-types" *ngIf="hasPayrollRole">
    <gp-context-pay-type class="context-item"
                         [forceDisplayValue]="payTypeTranslation?.key | translate: payTypeTranslation?.args">
    </gp-context-pay-type>
  </div>
  <span class="context-prefix" *ngIf="hasPayrollRole && hasPopulationFilterRoles">&#10072;</span>
  <div class="context-line context-populations" *ngIf="hasPopulationFilterRoles">
    <gp-context-population class="context-item"></gp-context-population>

    <div class="chip-wrapper"
         *ngIf="selectedFilterCount"
         [popover]="popoverTemplate"
         placement="bottom"
         triggers="mouseenter:mouseleave">
      <span class="chip-text default-cursor"> {{ 'CONTEXT_BAR.filters_selected' | translate:{count: selectedFilterCount} }} </span>
      &nbsp;<i aria-hidden="true" class="fa fa-light fa-times pointer chip-remover" (click)="clearAllFilters()"></i>
    </div>

    <ng-template #popoverTemplate>
      <table aria-describedby="selected-filters-table">
        <thead class="headers">
        <tr role="row">
          <th scope="col" colspan="3">
            {{ 'CONTEXT_BAR.selected_filters_are' | translate }}
          </th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let filter of selectedFilters; let i = index">
            <td class="text-right w-30">{{i + 1}}.&nbsp;</td>
            <td>{{ getTranslatedZoneName(filter) }}</td>
            <td>&nbsp;{{ getOperatorSymbol(filter.operator) }}&nbsp;</td>
            <td [ngSwitch]="filter.zoneType">
              <ng-container *ngSwitchCase="'DATE'">
                {{getLocalizedDate(filter.values[0])}}
              </ng-container>
              <ng-container *ngSwitchCase="'ENTITY'">
                {{filter.displayValue.toString() | translate}}
              </ng-container>
              <ng-container *ngSwitchCase="'LIST'">
                {{filter.displayValue.toString() | translate}}
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </div>
</div>


